<script setup>
import { onClickOutside } from '@vueuse/core';
import { Cross, Info }    from '../Icons';
import Suggestion from './Suggestion.vue'
import { vMaska } from "maska/vue"
import { ref }    from 'vue';
import {
	TooltipRoot,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from 'reka-ui'

const props = defineProps({
	name        : String,
	placeholder : String,
	maskOptions : Object,
	suggestions : Object,
	disabled    : Boolean,
	infoText    : String,
cyrillicOnly : Boolean,
});

const emit = defineEmits(['selectEmpty', 'selectSuggestion'])

const value = defineModel('value');

const targetElement = ref(null);
const suggestOpen   = ref(false);

const inputHandler = e => {
	if (!props.cyrillicOnly) return;

	const inputValue = e.target.value;
	const cleaned = inputValue.replace(/[^А-Яа-яЁё\s-]/g, '');
	value.value      = cleaned;

	if (inputValue !== cleaned) e.target.value = cleaned;

	emit('input', cleaned);
};

const selectSuggestion = suggestion => {
	value.value = suggestion.title;
	suggestOpen.value = false;
	emit('selectSuggestion', suggestion);
};

const clearInput = () => {
	value.value = null;
	emit('clearInput')
}

onClickOutside(targetElement, event => {
	const target = event.target.closest('.input__label')?.nextElementSibling;
	if (target && target == targetElement.value.$el)
		return;

	suggestOpen.value = false;
});
</script>

<template>
	<div class="input-wr">
		<label class="input__label" :class="{ disabled }">
			<input
				type="text"
				v-model="value"
				v-maska="maskOptions ? maskOptions : null"
				:name
				:placeholder
				:disabled
				@focus="suggestOpen = true"
				@input="inputHandler"
			>
			<button
				class="clear-input"
				v-if="value && (!disabled || !infoText)"
				@click="clearInput"
			>
				<Cross />
			</button>
			<TooltipProvider
				class="tooltip"
				v-else-if="disabled"
				:delay-duration="0"
			>
				<TooltipRoot>
					<TooltipTrigger class="input__info">
						<Info />
					</TooltipTrigger>
					<TooltipContent side="bottom" :side-offset="10">
						<div class="info-wr">{{ infoText }}</div>
					</TooltipContent>
				</TooltipRoot>
			</TooltipProvider>
		</label>
		<Suggestion
			v-if="suggestions && suggestOpen"
			ref="targetElement"
			:filterValue="value"
			:suggestions
			@selectSuggestion="selectSuggestion"
		/>
	</div>
</template>

<style lang='scss'>
.input-wr { position: relative }

.input__label {
	width: 100%;
	height: 60px;
	display: block;
	position: relative;
	background-color: #FFFFFF;
	border-radius: 12px;

	&.disabled { background-color: #F9F9F9 }

	input {
		width: 100%;
		height: 100%;
		font-size: 16px;
		font-family: "Raleway";
		font-weight: 500;
		background-color: transparent;
	}
}

.clear-input, .input__info {
	width: 20px;
	height: 20px;
	position: absolute;
	top: 20px;
	right: 16px;
}

.info-wr {
	padding: 12px 8px;
	background-color: #FFF;
	border: 1px dashed $yellow;
	border-radius: 12px;
}
</style>